angular.module("vgresiduos").controller("CollectionRequestInternalTransferCreateCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/transferencia-interna/nova`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.geracao) {
				queries.push({ key: "residueGeneration", value: $stateParams.geracao });
			}
			return queries;
		}
	}
]);
